import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { FullscreenLoader } from '@/shared/ui/states/FullscreenLoader';
import { useSessionQuery } from './useSessionQuery';

export function RequireAuth() {
  const location = useLocation();
  const session = useSessionQuery();

  if (session.isPending) return <FullscreenLoader />;
  if (!session.data?.profile || session.data.isAdmin) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}

export function RequireAdmin() {
  const location = useLocation();
  const session = useSessionQuery('admin');

  if (session.isPending) return <FullscreenLoader />;
  if (!session.data?.isAdmin) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return <Outlet />;
}

export function RequireGuest() {
  const location = useLocation();
  const session = useSessionQuery();

  if (session.isPending) return <FullscreenLoader />;
  if (session.data?.profile && !session.data.isAdmin) return <Navigate to="/app" replace state={location.state} />;
  return <Outlet />;
}
